<!--模板-->
<template>
  <div id="customization">
    <div class="content_bg">
      <h3>请告诉我们，您的需求计划？</h3>
      <h5>如果您需要旅行的帮助，可以告诉我们，我们可以帮助您完成旅行定制。</h5>
      <table>
        <tr>
          <td>出行日期</td>
          <td>
            <el-date-picker
              v-model="startTime"
              type="date"
              placeholder="开始日期">
            </el-date-picker>
            至
            <el-date-picker
              v-model="endTime"
              type="date"
              placeholder="结束日期">
            </el-date-picker>
          </td>
        </tr>
        <tr>
          <td>出行目的地</td>
          <td>
            <div style="width: 220px;display: inline-block">
              <el-input v-model="city" placeholder="请输入目的地城市名称"></el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td>出行人数</td>
          <td>
            <el-input-number v-model="nameNum" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number><span style="margin-left:10px">（人）</span>
          </td>
        </tr>
        <tr>
          <td>出行辅助</td>
          <td>
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="需要包车"></el-checkbox>
              <el-checkbox label="需要接送机"></el-checkbox>
              <el-checkbox label="需要导游"></el-checkbox>
              <el-checkbox label="全程一条龙包办"></el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
      </table>
      <h5 style="margin-bottom: 30px">告诉我们您的更多计划信息，以便我们更好地为您安排计划，例如：您的出行要求，出行需求，目的地情况等，您是我们的重要客户，我们竭尽全力为您安排一步到位！~</h5>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="请输入您的备注要求描述~"
        v-model="requireText">
      </el-input>

      <div class="btn_bg">
        <el-button type="primary" @click="addBtn">提交定制</el-button>
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
  export default {
    data() {
      return {
        checkList:[],
        requireText:'',
        nameNum:1,
        startTime:'',
        endTime:'',
        city:''
      };
    },
    methods:{
      handleChange(key){

      },
      addBtn(){
        if(this.startTime == ''){
          this.$message.error('请选择出发时间')
          return false
        }
        if(this.endTime == ''){
          this.$message.error('请选择结束时间')
          return false
        }
        if(this.city == ''){
          this.$message.error('请填写目的地城市')
          return false
        }
        console.log(this.startTime)
        console.log(this.endTime)
        console.log(this.city)
        console.log(this.checkList)
        console.log(this.nameNum)
        console.log(this.requireText)
        this.$message.success('您的信息，已提交到总部，我们会尽快与您取得联系！')

      }
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../scss/commonH5';
  .btn_bg{
    margin: 20px auto;
    text-align: center;
  }
  #customization{
    width: 100%;
    min-height: 60vh;
    color:#fff;
  }
  .content_bg{
    width: 1000px;
    margin: 50px auto;
    h3{
      text-align: center;
      margin: 10px 0;
    }
    table{
      margin: 30px 0;
      border-top:1px solid #ddd ;
      border-bottom:1px solid #ddd ;
      width: 100%;
      tr{
        width: 100%;
        display: flex;
      }
      td{
        padding: 20px 0;
        font-size: 17px;
      }
      td:first-child{
        width: 120px;
      }
      td:last-child{
        flex: 1;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/customization/customization.vue